import styled from '@emotion/styled/macro';
import { Buttons, Message } from '../../../common/TwoButtonModal/TwoButtonModal.styles';
import rem from '../../../utils/rem/rem';

export const StyledMessage = styled(Message)`
  margin-bottom: ${rem(16)};
`;

export const StyledButtons = styled(Buttons)`
  margin-top: ${rem(32)};
`;
